import { ChangeLessonStatus, changeCourseStatus, changeTopicStatus} from '@/api/course-builderapi'
export const StatusMixin = {
  data () {
    return {
      statusstatus:'asas'
    }
  },
  methods:{
    async ChangeStatus (status, id, index, type) {

      try {
        this.$vs.loading()

        const customerId = this.$store.getters.customerId


        const objpayload = {
          ids: [id],
          status:!status
        }
        if (type === 'Lesson') {

          await ChangeLessonStatus(customerId, objpayload)

          // this.lessonLists[index].status = !status

        } else if (type === 'Course') {
          await changeCourseStatus(customerId, objpayload)

        } else if (type === 'Topic') {
          await changeTopicStatus(customerId, objpayload)
          this.topicLists[index].status =  !status
        }

        this.$vs.notify({
          title: 'Success',
          text: 'Status changed Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } catch (error) {
        console.log(error)
        this.$vs.notify({
          title: 'warning',
          text: error.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
        // this.question_details[index].status = status

      } finally {
        this.$vs.loading.close()
      }
    }
  }
}
